<ng-template #customDetails let-product="product">
  <div class="custom-details">
    @if (product.speedRPM) {
      <p>
        <span class="title ff-bold m-r-4">{{ 'productListItem.speedRPM' | cxTranslate }}:</span>
        <span class="value">{{ getLabel(product.speedRPM, 'speedRPMs') }}</span>
      </p>
    }

    @if (product.outputHP) {
      <p>
        <span class="title ff-bold m-r-4">{{ 'productListItem.outputHP' | cxTranslate }}:</span>
        <span class="value">{{ getLabel(product.outputHP, 'outputHPs') }}</span>
      </p>
    }

    @if (product.voltage) {
      <p>
        <span class="title ff-bold m-r-4">{{ 'productListItem.voltage' | cxTranslate }} (V):</span>
        <span class="value">{{ getLabel(product.voltage, 'voltages') }}</span>
      </p>
    }

    @if (product.frameSize) {
      <p>
        <span class="title ff-bold m-r-4">{{ 'productListItem.frameSize' | cxTranslate }}:</span>
        <span class="value">{{ getLabel(product.frameSize, 'frameSizes') }}</span>
      </p>
    }

    @if (product.outputKW) {
      <p>
        <span class="title ff-bold m-r-4">{{ 'productListItem.outputKW' | cxTranslate }}:</span>
        <span class="value">{{ getLabel(product.outputKW, 'outputKWs') }}</span>
      </p>
    }

    @if (product.mounting) {
      <p>
        <span class="title ff-bold m-r-4">{{ 'productListItem.mounting' | cxTranslate }}:</span>
        <span class="value">{{ getLabel(product.mounting, 'mountings') }}</span>
      </p>
    }

    @if (product.phase) {
      <p>
        <span class="title ff-bold m-r-4">{{ 'productListItem.phase' | cxTranslate }}:</span>
        <span class="value">{{ getLabel(product.phase, 'phases') }}</span>
      </p>
    }

    @if (product.enclosure) {
      <p>
        <span class="title ff-bold m-r-4">{{ 'productListItem.enclosure' | cxTranslate }}:</span>
        <span class="value">{{ getLabel(product.enclosure, 'enclosures') }}</span>
      </p>
    }

    @if (product.application) {
      <p>
        <span class="title ff-bold m-r-4">{{ 'productListItem.application' | cxTranslate }}:</span>
        <span class="value">{{ product.application }}</span>
      </p>
    }
  </div>

  <p class="text-info d-flex m-t-20">
    <span class="d-flex material-symbols-outlined m-r-4"> info </span>
    {{ 'advancedSearch.noContent' | cxTranslate }}
  </p>
</ng-template>

<div class="container-product-list-item">
  <div class="media">
    <product-media [product]="product" format="product"></product-media>
  </div>

  <div class="content">
    <h3 class="box-product-name" [title]="product.name">
      <ng-template #productName>
        <span [innerHTML]="product.name"></span>
        @if (product.application) {
          <span class="m-l-4">({{ product.application }})</span>
        }
      </ng-template>

      @if (product.code && !product.isCustom) {
        <a
          tabindex="0"
          [routerLink]="
            {
              cxRoute: 'product',
              params: {
                code: product?.code,
                slug: slugify(product?.name),
                catalogNumber: product?.catalogNumber,
              },
            } | cxUrl
          "
          target="_blank"
          >
          <ng-container *ngTemplateOutlet="productName"> </ng-container>
        </a>
      } @else {
        <p class="m-b-0">
          <ng-container *ngTemplateOutlet="productName"> </ng-container>
        </p>
      }
    </h3>

    @if (product.isCustom) {
      <ng-container *ngTemplateOutlet="customDetails; context: { product }"> </ng-container>
    } @else {
      <div class="cod w-100">
        <strong class="m-r-4">Part #:</strong> <span>{{ product.partNumber }}</span>
      </div>

      <div class="catalog w-100">
        <strong class="m-r-4">{{ 'productRow.labels.catalog' | cxTranslate }} #:</strong> <span>{{ product.catalogNumber }}</span>
      </div>
      @if (product.price) {
        <div class="catalog w-100">
          <strong class="m-r-4">{{ 'productPrice.listPrice' | cxTranslate }}:</strong> <span>{{ product.price?.formattedValue }}</span>
        </div>
      }
    }
  </div>

  @if (!product.isCustom) {
    <div *smallerThan="DEVICE_SIZE.DESKTOP" class="key-features">
      <collapse-list [collapseList]="keyFeatures"></collapse-list>
    </div>
  }

  <div class="actions">
    <button class="btn btn-primary" (click)="addProduct(product)">Request Quote</button>

    @if (!product.isCustom) {
      <a [routerLink]="['/where-to-buy']" class="btn btn-primary" target="_blank">{{ 'productRow.actions.whereToBuy' | cxTranslate }}</a>
    }
  </div>

  @if (!product.isCustom) {
    <div *limitUp="DEVICE_SIZE.DESKTOP" class="key-features">
      <collapse-list [collapseList]="keyFeatures"></collapse-list>
    </div>
  }
</div>
